import playIcon from '../../../asset/images/icons/playback.svg';
import settingsIcon from '../../../asset/images/icons/quality.svg';

export const settings = [
    {
        title: 'playback speed',
        options: ['0.5', '1.0', '1.5', '2.0'],
        icon: playIcon,
    },
    {
        title: 'quality',
        options: ['auto', '720p', '480p', '360p'], // Also add '1080p here
        icon: settingsIcon,
    },
];
